import { get } from 'lodash-es';
import * as navigationActions from '../actions/navigationActions';
import * as eventActions from '../actions/eventActions';
import * as analyticsEvents from 'srcAlias/client/analytics';

const initialState = {
  segmentIndex: 0,
  pageIndex: 0,
};

const handlePiggybankEvent = (state, action) => {
  const { type } = action.event || {};
  switch (type) {
    case 'onChange':
    case 'onClose':
    case 'onOpen':
    case 'onClick':
      return analyticsEvents.trackEventAtKeyPath(
        {
          ...action.event,
          keyPath: action.event.name,
          state,
        },
        type
      );
  }
  return null;
};

export default (state = initialState, action) => {
  //NOSONAR
  switch (action.type) {
    case eventActions.INIT_EVENT: {
      return state;
    }

    case eventActions.PIGGYBANK_EVENT: {
      handlePiggybankEvent(get(action, 'event.state', {}), action);
      if (get(action, 'event.type') === 'onNavigate') {
        return {
          ...state,
          pageIndex: get(action, 'event.currentPageIndex'),
        };
      }
      return state;
    }

    case navigationActions.NEXT_PAGE: {
      return {
        ...state,
        pageIndex: state.pageIndex + 1,
      };
    }

    case navigationActions.NEXT_SEGMENT: {
      return {
        ...state,
        pageIndex: 0,
        segmentIndex: state.segmentIndex + 1,
      };
    }

    default:
      return state;
  }
};
